module.exports = __webpack_public_path__ + "static/media/Flipkart-Emblem.bc199e35.png";